import { useState, useEffect, useRef } from "react";
import BarraSuperior from "./barra_superior";
import AnimacionCarga from "./animacion_de_carga";
import "../css/animacion_de_carga.css";
import { obtenerInformes } from "../../functions/consultas";
import { tablaUsabilidad, crearTitulo } from "../../functions/gestion";

const Seguimiento = () => {
  const [animacionCarga, setCargando] = useState(true);
  const [datosInformes, setDatosInformes] = useState([]);
  const hasFetched = useRef(false);

  const capturarDatos = async () => {
    setCargando(true);
    try {
      const informes = await obtenerInformes();
      if (informes) {
        const datos = Array.isArray(informes) ? informes : Object.values(informes);
        setDatosInformes(datos);
      }
      console.log("✅ Datos obtenidos correctamente");
    } catch (error) {
      console.error("Error capturando datos:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      capturarDatos();
      hasFetched.current = true;
    }
  }, []);

  if (animacionCarga) return <AnimacionCarga />;

  return (
    <div>
      <BarraSuperior />
      <div className="BloqueModulo">
        <div>
          {crearTitulo('Resumen:')}
          <br />
          <p>• CLIENTES CON PLAN DE MÓDULOS ADMINISTRATIVOS + SOS</p>
          <br />
          {tablaUsabilidad(datosInformes, "Todo", "Activo")}
          <br />
          <p>• CLIENTES CON PLAN SOLO MÓDULO DE RONDAS</p>
          <br />
          {tablaUsabilidad(datosInformes, "Rondas", "Activo")}
          <br />
          <p>• CLIENTES CON PLANES DESACTIVADOS</p>
          <br />
          {tablaUsabilidad(datosInformes, "", "Desactivado")}
          <br />
        </div>
      </div>
    </div>
  );
};

export default Seguimiento;